import React, { useState, useEffect } from "react";
import dynamic from "next/dynamic";
const MotionDiv = dynamic(
  () => import("framer-motion").then(mod => mod.motion.div),
  { ssr: false }
);
const AnimatePresence = dynamic(
  () => import("framer-motion").then(mod => mod.AnimatePresence),
  { ssr: false }
);
import { BreakingNewsAction } from "@/server-actions/article-actions";
import { ArticlesForCardQuery } from "@/types/generated";
import Link from "next/link";
import { articlePath } from "@/lib/userUtils";

export default function BreakingNewsSlider() {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const [headlines, setHeadlines] = useState<ArticlesForCardQuery["articles"]>(
    []
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (paused) return;

    const interval = setInterval(() => {
      if (headlines.length > 0) {
        setIndex((prev) => (prev + 1) % headlines.length);
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [paused, headlines.length]);

  const loadMoreArticles = React.useCallback(async (limit: number) => {
    setLoading(true);
    const res = await BreakingNewsAction(limit);

    if (res?.success) {
      const newArticles = res?.data ?? [];
      console.log("New articles loaded:", newArticles);

      setHeadlines(newArticles);

      setLoading(false);
    } else {
      // Handle error here
      console.error(res?.message);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadMoreArticles(5);
  }, []);

  return loading ? (
    <div className="relative h-[2.5rem] sm:h-[1.2rem] flex items-center justify-center">
      <span>Loading...</span>
    </div>
  ) : (
    <div
      className="relative h-[2.5rem] sm:h-[1.2rem] overflow-hidden w-full flex-1 flex items-center"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <AnimatePresence mode="wait">
        <MotionDiv
          key={headlines[index]?.documentId}
          initial={{ y: "100%", opacity: 0 }}
          animate={{ y: "0%", opacity: 1 }}
          exit={{ y: "-100%", opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeInOut" }}
          className="absolute w-full font-semibold"
        >
          <Link
            href={articlePath(headlines[index])}
            className=" cursor-pointer hover:underline overflow-hidden text-ellipsis break-words line-clamp-2 sm:line-clamp-1"
          >
            {headlines[index]?.title}
          </Link>
        </MotionDiv>
      </AnimatePresence>
    </div>
  );
}
